import React from 'react';
import { hot } from 'react-hot-loader/root';
import { Provider } from 'react-redux';
import { ApolloClientContext } from '../util/apollo';
import { BrowserHistoryContext }  from './history';
import Screen from './Screen';

const App = (props) => {
    const {
        apolloClient,
        history,
        initialView,
        router,
        store
    } = props;

    return (
        <ApolloClientContext.Provider value={apolloClient}>
            <Provider store={store}>
                <BrowserHistoryContext.Provider value={history}>
                    <Screen
                        history={history}
                        initialView={initialView}
                        router={router}
                        store={store}
                    />
                </BrowserHistoryContext.Provider>
            </Provider>
        </ApolloClientContext.Provider>
    );
};

export default hot(App);
